import React from 'react';
import * as XLSX from 'xlsx';

const RecordRejectedModule = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const rejectedModuleData = inspectionData.RecordRejectedModuleDuringInspection;

  if (!rejectedModuleData) {
    return <p className="text-gray-500">No Rejected Module data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push(['Date', 'Is Saved', 'Serial Number', 'Defect Name']);

    // Add data rows
    rejectedModuleData.rejectedModules.forEach((module) => {
      worksheetData.push([
        rejectedModuleData.date,
        rejectedModuleData.isSaved.toString(),
        module.serialNumber,
        module.defectName,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'RejectedModules');
    XLSX.writeFile(workbook, 'RejectedModulesData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          Record Rejected Modules - {rejectedModuleData.date}
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      <div className="mt-4">
        {/* <h4 className="font-semibold text-gray-700 mb-2">Details</h4> */}
        {/* <p><strong>Is Saved:</strong> {rejectedModuleData.isSaved ? 'Yes' : 'No'}</p> */}
      </div>

      <div className="mt-4">
        <h4 className="font-semibold text-gray-700 mb-2">Rejected Modules</h4>
        {rejectedModuleData.rejectedModules.length === 0 ? (
          <p className="text-gray-600">No rejected modules recorded.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border rounded-lg">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 text-left text-gray-700">Serial Number</th>
                  <th className="px-4 py-2 text-left text-gray-700">Defect Name</th>
                </tr>
              </thead>
              <tbody>
                {rejectedModuleData.rejectedModules.map((module, index) => (
                  <tr key={index} className="border-t">
                    <td className="px-4 py-2 text-gray-600">{module.serialNumber || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{module.defectName || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecordRejectedModule;